module.exports = {"510705101":"桑枣镇","510705102":"花荄镇","510705103":"黄土镇","510705104":"塔水镇","510705105":"秀水镇","510705106":"河清镇","510705108":"界牌镇","510705110":"雎水镇","510705116":"千佛镇","510705202":"高川乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510705.json
// module id = 2432
// module chunks = 0